import React, { FC, PropsWithChildren } from 'react'
import { Box, Container } from '@moonpig/launchpad-components'
import { ProductModule } from '../types'

export const ProductModuleSection: FC<PropsWithChildren<ProductModule>> = ({
  withContainer = false,
  children,
  ...rest
}) => {
  return (
    <Box {...rest}>
      {withContainer ? (
        <Container
          data-testid="mp-find-product-module-section-container"
          limitWidth
        >
          {children}
        </Container>
      ) : (
        children
      )}
    </Box>
  )
}
